import React, { useState } from 'react';
import { Row, Col } from 'antd';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ImagemServico from 'assets/img/servico.svg';
import InputText from 'components/InputText';
import InputSelect from 'components/InputSelect';
import InputTextArea from 'components/InputTextArea';
import Button from 'components/Button';
import { servicosSistemaEditar } from 'routes/paths';
import { clearErroChange } from 'utils/formUtils';
import { ENUM_PERMISSAO } from 'utils/permissao';
import { formatarIdentificador } from './FormServicoSistema';
import * as S from '../styles';
import ComponentEditorTexto from 'components/EditorTexto';
import EditorTextoExibir from 'components/EditorTexto/exibir';
import { altImageServico } from 'utils/acessibilidade';

export default function ContainerServico({
  errors,
  control,
  getValues,
  setValue,
  setError,
  optionsSituacoes,
  onSubmit,
  disabled = false,
}) {
  const history = useHistory();

  const [exibirEditarApagar, setExibirEditarApagar] = useState(false);

  const user = useSelector(state => state.sefaz.userProfile);

  React.useEffect(() => {
    if (user?.permission.includes(ENUM_PERMISSAO.SUP0801.codigo)) setExibirEditarApagar(true);
  }, [user]);

  const handleChange = e => {
    const { name, value } = e.target;
    setValue(name, value);
    clearErroChange(name, value, errors, setError);
    if (name === 'nomeServico') {
      handleChange(formatarIdentificador(value));
    }
  };

  return (
    <form>
      <Row>
        <Col xs={24} sm={5} md={5} lg={5} xl={5}>
          <S.Descricao>
            Para cadastrar um Serviço preencha todas as informações solicitadas, o serviço ficará disponível para todos
            imediatamente após salvar.
          </S.Descricao>
          {disabled && exibirEditarApagar && (
            <S.ContainButton>
              <Button text={'Editar'} clickAction={() => history.push(servicosSistemaEditar)} />
            </S.ContainButton>
          )}

          <InputTextArea
            label="* Nome do Serviço"
            name="nomeServico"
            errors={errors}
            placeholder={'Nome do Serviço'}
            control={control}
            onChange={handleChange}
            maxLength={200}
            rows={3}
            disabled={disabled}
          />
          <InputTextArea
            label="* Descrição do Serviço"
            name="descricaoServico"
            errors={errors}
            placeholder={'Descrição do Serviço'}
            control={control}
            onChange={handleChange}
            maxLength={150}
            rows={2}
            disabled={disabled}
          />
          {disabled ? (
            <EditorTextoExibir
              mensagemHtml={getValues?.('documentos')}
              label="* Documentos necessários"
              disabled={disabled}
            />
          ) : (
            <ComponentEditorTexto
              data={getValues?.('documentos')}
              name="documentos"
              label="* Documentos necessários"
              handleChange={handleChange}
              errors={errors}
              tooltipSwitchText="Visualizar Mensagem"
            />
          )}
          <InputText
            label="* Identificador"
            name="identificadorServico"
            errors={errors}
            placeholder={'Identificador único do serviço'}
            control={control}
            onChange={handleChange}
            maxLength={100}
            disabled={disabled}
          />
          <InputSelect
            label="* Status"
            name="situacaoId"
            errors={errors}
            placeholder={'Status'}
            control={control}
            options={optionsSituacoes}
            disabled={disabled}
          />
        </Col>
        <Col xs={24} sm={16} md={16} lg={16} xl={16} style={{ margin: 'auto' }}>
          <S.ImagemServicoSistema data-testid="Imagem Page Servico" src={ImagemServico} alt={altImageServico} />
        </Col>
      </Row>
      {!disabled && <Button text={'Salvar'} clickAction={onSubmit} css={{ margin: '7px 0px 7px 7px' }} />}
    </form>
  );
}
